import ReCAPTCHA from 'react-google-recaptcha';
const win: any = window;
const RecaptchaKey = win["RECAPTCHA_SITE_KEY"];
interface CaptchaCustomProps {
  rtl?: boolean;
  onChange?: (value: string | null) => void;
}
const CaptchaCustom: React.FC<CaptchaCustomProps> = ({ rtl = false, onChange }) => {
  const dir = rtl ? "right" : "left";
  return (
    <div className={`fontFamily-${dir}`}>
      <ReCAPTCHA
        sitekey={RecaptchaKey}
        hl={rtl ? "ar" : "en"}
        onChange={onChange}
      />
    </div>
  );
};

export default CaptchaCustom;
